import nftfyBnb from '@assets/icons/bnb-nftfy.png'
import nftfyDai from '@assets/icons/dai-nftfy.png'
import nftfyBusd from '@assets/icons/nftfy-busd.svg'
import nftfyWeth from '@assets/icons/weth-nftfy.svg'
import { FarmForm } from '@components/farm/FarmForm'
import { DefaultPageTemplate } from '@components/shared/templates/DefaultPageTemplate'
import { GetServerSideProps, NextPage } from 'next'
import styled from 'styled-components'
import MarketplaceHeader from '@components/marketplace/MarketplaceHeader'
import { SupportedNetworks } from '@config'
import { useGlobalConfig } from '../../hooks/ConfigHook'

interface FarmPageProps {
  chainId: number
}

const Farm: NextPage<FarmPageProps> = ({ chainId }: FarmPageProps) => {
  const { farms } = useGlobalConfig()
  const { wethNftfy, daiNftfy, bnbNftfy, busdNftfy, ethNftfy } = farms
  return (
    <DefaultPageTemplate header={<MarketplaceHeader chainId={chainId} />}>
      <S.Container>
        <S.Content>
          <FarmForm icon={nftfyWeth.src} {...ethNftfy} />
          <FarmForm icon={nftfyWeth.src} {...wethNftfy} />
          <FarmForm icon={nftfyBnb.src} {...bnbNftfy} />
        </S.Content>
        <S.Content>
          <FarmForm icon={nftfyDai.src} {...daiNftfy} />
          <FarmForm icon={nftfyBusd.src} {...busdNftfy} />
        </S.Content>
      </S.Container>
    </DefaultPageTemplate>
  )
}
export const S = {
  Container: styled.div`
    margin: 0 auto;
    min-height: calc(100vh - 96px);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  `,
  Content: styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 32px;
    margin-top: 32px;

    > div {
      margin-right: 20px;
    }

    @media (max-width: ${props => props.theme.viewport.desktop}) {
      > div {
        margin-right: 0;
        margin-top: 20px;
        margin-bottom: 20px;
      }

      padding: 5px;
      flex-direction: column;
    }
  `
}

export default Farm

export const getServerSideProps: GetServerSideProps = async context => {
  const chainId = context.params?.chainId || SupportedNetworks.ethereum

  return {
    props: {
      chainId: Number(chainId)
    }
  }
}
